module.exports = __webpack_public_path__ + "img/blue-down-arrow.447a1207.svg";